import React, { useCallback, useContext, useEffect, useLayoutEffect, useRef, useState } from "react";
import Slider from "react-slick";

import styled from "styled-components";

import Left from '../assets/icons/icon_left.png';
import Right from '../assets/icons/icon_right.png';
import Default from '../assets/icons/icon_first.png';

import { convertTxtToKorean, generateRandomString } from "../utils/commonFunctions";
import { MyContext } from "../context/MyContext";
import { Tooltip } from "react-tooltip";

const VALID_URL = /^https?:\/\//;

const Carosel = React.memo(props => {

  const { openNav, isMobile } = useContext(MyContext);

  const { slides, handleClick, chat, search, template, socrates } = props;

  const imgRefs = useRef(Array(slides?.length).fill(null));

  const [cardNum, setCardNum] = useState((isMobile || slides.length === 1) ? 1 : (!isMobile && slides.length >= 4) ? 4 : slides.length)
  const [viewWidth, setViewWidth] = useState(null)

  const handleResize = () => {

    const viewportWidth = window.innerWidth;
    let cnt;

    if (viewportWidth < 769) {
      cnt = socrates ? 2 : 1
    } else if (viewWidth >= 769 && 1024 > viewWidth) {
      cnt = socrates ? 3 : 4
    } else {
      cnt = 4
    }
    if (cnt > slides.length) {
      cnt = slides.length
    } else {
      setSettings(prevSettings => ({
        ...prevSettings,
        infinite: true,
        prevArrow: <Prev />,
        nextArrow: <Next />,
      }))
    }
    setCardNum(cnt)
    setViewWidth(viewportWidth)
  };

  useLayoutEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [openNav]);

  useEffect(() => {
    handleResize()
  }, [openNav])

  const float = {
    position: 'absolute',
    top: '50%',
    zIndex: '1'
  }


  const Prev = props => {
    const { style, onClick } = props;

    return (
      <div
        style={
          chat ?
            {
              ...float,
              left: '-2%'
            }
            :
            null
        }
        className="slick-btn__wrapper" onClick={onClick}>
        <img src={Left} alt="prev-btn" />
      </div>
    )
  }

  const Next = props => {
    const { style, onClick } = props;

    return (
      <div
        style={
          chat ?
            {
              ...float,
              right: '-2%'
            }
            :
            null
        }
        className="slick-btn__wrapper" onClick={onClick}>
        <img src={Right} alt="prev-btn" />
      </div>
    )
  }

  const [settings, setSettings] = useState({
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: cardNum,
    slidesToScroll: 1,
    pauseOnHover: true,
    draggable: true,
    prevArrow: (!isMobile && slides.length > 4) ? <Prev /> : null,
    nextArrow: (!isMobile && slides.length > 4) ? <Next /> : null,
    centerMode: (chat && cardNum >= 5) ? true : false,
  })

  const handleClickSlide = (e, item, key) => {
    if (!chat) {
      let link = item[key];
      let isValid = VALID_URL.test(link)
      if (!isValid) {
        link = 'http://' + link;
      }
      window.open(link, '_blank')
    } else {
      handleClick(item)
    }

  }

  useLayoutEffect(() => {
    if (isMobile) {
      setSettings(prevSettings => ({
        ...prevSettings,
        infinite: false,
        prevArrow: null,
        nextArrow: null,
      }));
      return
    }
    if (chat) {
      let nums = 0;
      slides.map((item, idx) => (
        nums += item?.image?.length
      ))
      setSettings(prev => ({
        ...prev,
        slidesToShow: nums >= 5 ? 4 : nums,
        centerMode: nums >= 5 ? true : false,
        prevArrow: nums >= 5 ? <Prev /> : null,
        nextArrow: nums >= 5 ? <Next /> : null,
      }))
      return
    }
    else if (slides.length <= 4) {
      setSettings(prevSettings => ({
        ...prevSettings,
        infinite: false,
        prevArrow: null,
        nextArrow: null,
      }));
    } else if (slides.length >= 5) {
      setSettings(prevSettings => ({
        ...prevSettings,
        infinite: true,
        prevArrow: <Prev />,
        nextArrow: <Next />,
      }));
    } else {

    }

  }, [slides]);

  return (
    <Style cardnum={cardNum} width={viewWidth} chat={chat} search={search}>
      <Slider {...settings} >
        {
          chat
            ?
            slides.map(slide => {
              const newSlide = [...slide.image];
              return (
                newSlide.map((newItem, newIdx) => (
                  <div
                    className={`slide-wrapper ${cardNum===1?"!flex !justify-center":""}`}
                    key={newItem.IMG_SRC + newIdx}
                    onClick={() => handleClick(slide)}
                  >
                    <img
                      ref={(el) => { imgRefs.current[newIdx] = el }}
                      className="ref-img"
                      style={slides.length === 1 ? { maxWidth: '200px' } : null}
                      src={newItem.IMG_SRC}
                      alt="news-img"
                      key={newItem.title + newIdx}
                    />
                  </div>
                ))
              )
            })
            :
            search
              ?
              slides.map((slide, idx) => {
                return (
                  <div
                    className="slide-wrapper rec__preview__list"
                    key={idx}
                    onClick={(e) => handleClickSlide(e, slide, 'url')}
                    ref={(el) => { imgRefs.current[idx] = el }}
                  >
                    <img
                      // src={slide.IMG_data.length !== 0 && slide.IMG_data[0].IMG_SRC}
                      src={
                        slide.IMG_data.length > 0
                          ? (slide.IMG_data.find(item => item?.IMG_SRC)?.IMG_SRC || null)
                          : null
                      }
                      alt="search_img"

                      className="slide-thumbnail"
                    />
                    <div className="rec__preview__summary">
                      <p className="label-txt">{slide.TITLE}</p>
                      <p>{slide.CONTENT}</p>
                      {/* <p>영업 시간 {slide.open}</p>
                      <p>휴무 {slide.close}</p>
                      <p>{slide.price}</p>
                      <p>연락처 {slide.contact}</p> */}
                    </div>
                    <div className="rec__preview__detail">
                      <p className="rec__preview__sub">{slide.Keywords}</p>
                      {/* <p className="rec__preview__desc">{slide.description}</p> */}
                    </div>
                  </div>
                )
              })
              : template
                ?
                slides?.map((slids) => (
                  slids.map((unit, unitIdx) => {
                    return (
                      typeof (unit) !== 'string'
                      &&
                      <div key={generateRandomString(unitIdx)} className="tmp__ls-it-item">
                        {Object.entries(unit).map(([key, value]) => (
                          <div key={generateRandomString(key.length)} className="tmp__ls-it-row">
                            <p className="tmp__ls-it-key">{convertTxtToKorean(key)}</p>
                            {
                              key === 'download'
                                ?
                                <a href={value} target="_blank" className="tmp__ls-it-link">다운로드</a>
                                :
                                <p className="tmp__ls-it-value">{value}</p>
                            }
                          </div>
                        ))}
                      </div>
                    )
                  })
                ))
                :
                socrates
                  ?
                  slides?.map((slide, idx) => {
                    return (
                      <SlideWrapper
                        className="slide-wrapper text-wrapper flx-box"
                        onClick={() => handleClick(slide)}
                        key={`${slide.color}-${idx}`}
                        borderColor={slide.color}
                      >
                        {/* <img src={slide.img_src} alt="" /> */}
                        <img
                          className="main-socra"
                          src={(slide?.img_data && slide?.img_extension) ? `data:image/${slide.img_extension};base64,${slide.img_data}` : Default}
                          alt="" />
                        <p className="slide-name">{slide.title}</p>
                        <Tooltip place="right" offset={10} id={slide.title} style={{ width: '200px', whiteSpace: 'normal', lineHeight: '1rem', display: slide.explain.length > 80 ? '' : 'none' }} />
                        <a
                          data-tooltip-id={slide.title}
                          data-tooltip-content=''
                          className="socrates-sample"
                        >
                          <p className="slide-content">{slide.explain.length > 80 ? `${slide.explain.substr(0, 80)}...` : slide.explain}</p>
                        </a>
                      </SlideWrapper>
                    )
                  })
                  :
                  slides?.map((slide, idx) => {
                    return (
                      <div
                        className="slide-wrapper"
                        onClick={() => handleClick(slide.rep_question)}
                        key={generateRandomString(idx)}>

                        <img
                          src={slide.img}
                          alt="slide-preview"
                          className="slide-img"
                          ref={(el) => { imgRefs.current[idx] = el }}
                        />
                        <p className="slide-category">{slide.category}</p>
                        <p className="slide-sample">{slide.rep_question}</p>
                        <p className="slide-anchor">{`답변보기 >`}</p>
                      </div>
                    )
                  })
        }

      </Slider>
    </Style >
  )
})

export default Carosel

const Style = styled.div`
  overflow: hidden;
  width: 100%;
  margin: ${props => (props.chat || props.search || props.template) ? 'auto' : '0 auto'};
  color: #333;
  max-width: 1596px;
  flex-direction: column;
  justify-content: center;
  display: flex important;
  flex: 1;
  .slick-slider {
    position: ${props => props.chat ? 'static' : 'relative'};
    display:flex;
    margin: auto;
    max-height: ${props => props.chat ? '181px' : ''};
  }
  .slick-slide {
    width: ${props => props.chat ? '200px' : ''};
    .slide-sample {
      margin-top: 2px;
      line-height: 150%;
      width: 70%;
    }
}
  .slick-list {
    // 부모
    box-sizing: border-box;
    width: 100vw;
    margin: auto;
  }

  .slick-slide > div {
    // 자식 안에 div
    margin: 10px;
    box-sizing: border-box;
    position: relative;
    cursor:pointer;
    
  }
  .slick-slide > div {
    .slide-img {
      transition: all ease 1s;
      width: 100%;
    }
    .slide-img:hover {
      filter: ${props => props.search ? 'brightness(1.5)' : 'brightness(2)'};
    }
  }
  .slide-category {
    position: absolute;
    color: white;
    font-weight: 400;
    font-size:  ${props => props.cardnum === 1 ? '10px' : '16px'}; 
    top: ${props => props.cardnum === 1 ? '10px' : '27px'};
    left: ${props => props.cardnum === 1 ? '10px' : '29px'};
  }
  .slide-sample {
    position: absolute;
    color: white;
    top: ${props => props.cardnum === 1 ? '30px' : '46px'};
    left: ${props => props.cardnum === 1 ? '10px' : '29px'};
    font-size: ${props => props.cardnum === 1 ? '12px' : props.cardnum > 1 && props.cardnum < 4 ? '18px' : '100%'};
    height:  ${props => props.cardnum === 1 ? '44%' : ''};
    overflow: hidden;
    tect-overflow: ellipsis;
  }
  .slide-anchor{
    position: absolute;
    bottom: ${props => props.cardnum === 1 ? '10px' : '27px;'};
    color: white;
    left: ${props => props.cardnum === 1 ? '10px' : '29px'};
    font-weight: 400;
    font-size: ${props => props.cardnum === 1 ? '10px' : '16px'};
  }

  .slide-title {
    position: absolute;
    top: 10px;
    left: 10px;
    color: white;
        
  }
  .slide-thumbnail {
   border-radius: 10px;
  }
  .slide-link {
    position: absolute;
    bottom: 30px;
    left: 10px;
    color: white;
  }
  .slick-btn__wrapper {
    marin: initial;
    margin: auto 5px;
    background: white;
    border-radius: 50%;
    cursor:pointer;
    box-shadow: 1px 2px 7px darkgray;
  }

  }
  @media (min-width: 768px) {
    .slick-btn__wrapper {
      width: 20px;
      min-width: 20px;
      height: 20px;
      img {
        width: 5px !important;
        padding: 6px 7px;
      }
     }
     .slide-thumbnail {
      min-height: 200px;
      min-width: 200px;
      width: 200px;
      height: 200px;
     }
  }
  @media (max-width: 768px) {
   .slick-btn__wrapper {
    width: 20px;
    min-width: 20px;
    height: 20px;
    img {
     width: 5px !important;
     padding: 7px 8px;
    }
   }
   .slide-thumbnail {
    min-height: 150px;
    min-width: 150px;
    width: 150px;
    height: 150px;
   }
  }
`
const SlideWrapper = styled.div`
display: flex;
align-items: center;
justify-content: center;
border-radius: 20px;
border: 2px solid ${(props) => props.borderColor};
`;